const notes = [
  {
    title: 'Closures and use cases in React',
    author: 'Antonija Šimić',
    date: '2026-08-04',
    level: 'beginner',
    tags: 'Javascript, React, Closures, Scope',
    id: 21,
    intro:
      'Closures are not interview trivia — you use them every day in React. A practical look at what they are, where they show up in hooks and handlers, and why fundamentals still matter.',
    subtitle: 'Why do closures exist and where do you use them?',
  },
  {
    title: 'Server state vs client state',
    author: 'Antonija Šimić',
    date: '2026-07-29',
    level: 'senior',
    tags: 'React, React Query, TanStack Query, State',
    id: 19,
    intro:
      'A practical guide to the boundary between server state and client state in React — and when TanStack Query should own remote data instead of useState and useEffect.',
    subtitle: 'Where does React Query end and useState begin?',
  },
  {
    title: 'Avoiding waterfalls with Suspense and streaming',
    author: 'Antonija Šimić',
    date: '2026-01-21',
    level: 'senior',
    tags: 'React, Suspense, Streaming, Performance',
    id: 20,
    intro:
      'A practical guide to spotting request waterfalls in React and breaking them with parallel fetching, granular Suspense boundaries, and streaming UI.',
    subtitle: 'Why is my page waiting on everything?',
  },
  {
    title: 'Generics',
    author: 'Antonija Šimić',
    date: '2024-02-15',
    level: 'senior',
    tags: 'Typescript, Generics',
    id: 18,
    intro:
      'A practical guide to understanding generics in TypeScript, with clear examples that show how to use them effectively to create reusable and type-safe components.',
    subtitle: 'How to create reusable components?',
  },
  {
    title: 'Throttle and debounce',
    author: 'Antonija Šimić',
    date: '2024-03-01',
    level: 'senior',
    tags: 'Javascript, Performance',
    id: 17,
    intro:
      'A practical guide to understanding the difference between throttle and debounce in JavaScript, with clear examples that show how to use them effectively to optimize performance.',
    subtitle: 'How to optimize performance?',
  },
  {
    title: 'Reference vs Value',
    author: 'Antonija Šimić',
    date: '2024-05-01',
    level: 'beginner',
    tags: 'Javascript, Reference, Value',
    id: 15,
    intro:
      'A practical guide to understanding the difference between reference and value types in JavaScript, with clear examples that show how they affect memory management and performance.',
    subtitle: 'What is the difference?',
  },
  {
    title: 'Cleanup function',
    author: 'Antonija Šimić',
    date: '2025-01-15',
    level: 'beginner',
    tags: 'React, useEffect',
    id: 14,
    intro:
      'A practical guide to understanding cleanup functions in React, with clear examples that show how to use them effectively to prevent memory leaks and optimize performance.',
    subtitle: 'How to prevent memory leaks?',
  },
  {
    date: '2025-04-19',
    author: 'Antonija Šimić',
    level: 'beginner',
    tags: 'React, useState',
    title: 'Regular variables and useState',
    subtitle: 'Do you want to trigger a rerender?',
    id: 10,
    intro:
      'A practical guide to understanding the difference between regular variables and state in React, with clear examples that show why only state updates trigger UI changes.',
  },
  {
    date: '2024-12-08',
    author: 'Antonija Šimić',
    title: 'When does a component rerender?',
    level: 'beginner',
    tags: 'React, Performance',
    id: 13,
    intro:
      'A comprehensive guide to understanding component re-rendering in React, with practical examples and tips to optimize performance and avoid unnecessary renders.',
    subtitle: 'How to avoid unnecessary renders?',
  },
  {
    date: '2025-02-08',
    title: 'Paint vs Render',
    author: 'Antonija Šimić',
    level: 'senior',
    tags: 'React, Performance, Rendering',
    id: 12,
    subtitle: 'What is paint in React?',
    intro:
      'A deep dive into the differences between painting and rendering in React, with practical examples to help developers optimize their applications for better performance.',
  },
  {
    date: '2025-03-11',
    author: 'Antonija Šimić',
    level: 'senior',
    tags: 'React, hooks',
    title: 'Two effects in React',
    subtitle: 'When to use which?',
    id: 11,
    intro:
      'A practical guide to understanding the differences between useLayoutEffect and useEffect in React, with clear examples that show when to use each hook for optimal performance.',
  },
  {
    date: '2024-01-15',
    author: 'Antonija Šimić',
    level: 'beginner',
    tags: 'Javascript, Algorithms',
    title: 'All about reduce',
    subtitle: 'Decrease the complexity of your code',
    id: 9,
    intro:
      'Reduce method is a method that is used to reduce an array to a single value. It is a very useful method when you want to sum up all the elements of an array or when you want to find the maximum or minimum value of an array.',
  },
  {
    date: '2024-06-21',
    author: 'Antonija Šimić',
    level: 'beginner',
    tags: 'Javascript, Arrays, Methods',
    title: 'Group by method',
    subtitle: 'New method in Javascript',
    id: 8,
    intro: 'I decided to write a post to clarify it for myself and for others',
  },
  {
    date: '2024-08-26',
    author: 'Antonija Šimić',
    level: 'beginner',
    tags: 'Javascript, Arrays, Rest',
    title: 'Spread and rest operator',
    subtitle: 'What is the difference?',
    id: 0,
    intro:
      'I have been using spread and rest operator for a while now. But I never really understood the difference between them. I decided to write a post about it to clarify it for myself and for others. Here is a short explanation. Spread operator is used to split up array elements or object properties. Rest operator is used to merge a list of function arguments into an array.',
  },
  {
    date: '2021-09-01',
    author: 'Antonija Šimić',
    level: 'beginner',
    tags: 'Javascript, Arrays, Sort',
    title: 'Reintroduction to sort method',
    subtitle:
      'It is time to know how this method works even in the middle of the night',
    id: 1,
    intro:
      'I have a small trauma when it comes to this little array method in Javascript.',
  },
  {
    date: '2023-08-31',
    author: 'Antonija Šimić',
    level: 'beginner',
    tags: 'Javascript, Scope',
    title: 'What is a lexical scope?',
    subtitle:
      'I know what lexical means in lingustics, but what about Javascript?',
    id: 2,
    intro:
      'Of course I know what lexical means, this is one of the rare cases where my diploma in linguistics helps me.',
  },
  {
    date: '2022-04-14',
    author: 'Antonija Šimić',
    level: 'beginner',
    tags: 'Javascript, Functional programming',
    title: 'What is a pure function?',
    subtitle: 'Stay away from dirty and smelly code',
    id: 3,
    intro:
      'I have been hearing about pure functions for a while now. I never really understood why. I decided to write a post about it to clarify it for myself and for others.',
  },
  {
    date: '2021-06-28',
    author: 'Antonija Šimić',
    level: 'beginner',
    tags: 'Javascript, Fetch, Data, React',
    title: 'How to fetch data in React?',
    subtitle: 'You can not be developer without handling data',
    id: 4,
    intro:
      'I have been using fetch method for a while now. But I never really understood how it works. I decided to write a post about it to clarify it for myself and for others. Here is a short explanation. Fetch method is a modern replacement for XMLHttpRequest. It is a simple and powerful window method that allows you to fetch resources across the network. It is promise-based, so you can use it with async/await.',
  },
  {
    date: '2022-07-31',
    author: 'Antonija Šimić',
    level: 'beginner',
    tags: 'Javascript, Fundamentals, ES6',
    title: 'Double question mark operator',
    subtitle: 'What is this all about?',
    id: 5,
    intro:
      'I have been seeing this operator a lot lately. I know that it is called double question mark operator.',
  },
  {
    date: '2022-02-15',
    author: 'Antonija Šimić',
    level: 'beginner',
    tags: 'React, useRef, useState',
    title: 'When to use useRef and useState?',
    subtitle: 'Be careful of rerendering',
    id: 6,
    intro: 'Let us see when to use which',
  },
  {
    date: '2023-09-15',
    author: 'Antonija Šimić',
    level: 'beginner',
    id: 7,
    tags: 'Codewars, Javascript, Algorithms',
    title: 'String incrementer',
    subtitle: 'Increment the number in a string',
    intro: 'I tried my luck with DSA',
  },
]

export default notes
